import { Job } from '@empathybroker/tsclient-index/dist/models/job';

import { GetterClass, IndexState } from '../../../models';

export class JobsGetter implements GetterClass {

  public static execute(state: IndexState): Job[] {
    return state.jobs;
  }

}
